import React from 'react';
import classes from './SlotLabel.module.css';
import moment from 'moment-timezone';
import { MdDelete } from 'react-icons/md';
import { MdEdit } from 'react-icons/md';
import clsx from 'clsx';
const timezone = 'Asia/Karachi';
const SlotLabel = ({ label, onClick, className }) => {
  function formatTimeRange(timeRange, timezone) {
    // Split the time range into start and end times
    const [start, end] = timeRange?.split(' - ');

    // Helper function to format a single time
    const formatTime = (time) => {
      return moment.tz(time, timezone).format('hh:mm A');
    };

    // Format start and end times
    const formattedStart = formatTime(start);
    const formattedEnd = formatTime(end);

    return `${formattedStart} - ${formattedEnd}`;
  }
  return (
    <>
      {label ? (
        <span
          className={clsx(classes.wrapper, className)}
          onClick={() => {
            if (typeof onClick === 'function') onClick();
          }}>
          {/* <ul className={classes.quickAction}>
            <li>
              <span>
                <MdDelete />
              </span>
              <span>
                <MdEdit />
              </span>
            </li>
            <li></li>
          </ul> */}
          {formatTimeRange(label, timezone)}
        </span>
      ) : null}
    </>
  );
};

export default SlotLabel;
